import { Printer, Share2, Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { cur } from '@/lib/currency';

function fmt(n) { return Number(n || 0).toLocaleString('ar-EG', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

const METHOD_ICON = { cash: '💵', bank: '🏦', check: '📝', other: '💳' };
const METHOD_LABEL = { cash: 'نقدي', bank: 'تحويل', check: 'شيك', other: 'أخرى' };

function getMethodKey(pmt) {
  const journalName = Array.isArray(pmt.journal_id) ? pmt.journal_id[1] : (pmt.journal_id || '');
  if (journalName.toLowerCase().includes('cash') || journalName.includes('نقد') || journalName.includes('صندوق')) return 'cash';
  if (journalName.toLowerCase().includes('bank') || journalName.includes('بنك')) return 'bank';
  return 'other';
}

export default function CollectionHistoryCard({ payment, onShare, showRep = false }) {
  const navigate = useNavigate();
  const customerName = Array.isArray(payment.partner_id) ? payment.partner_id[1] : (payment.partner_id || '—');
  const repName = Array.isArray(payment.salesman) ? payment.salesman[1] : '';
  const methodKey = getMethodKey(payment);
  const dateStr = payment.date ? new Date(payment.date).toLocaleDateString('ar-EG', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';
  const timeStr = payment.create_date ? new Date(payment.create_date.replace(' ', 'T')).toLocaleTimeString('ar-EG', { hour: '2-digit', minute: '2-digit' }) : '';

  return (
    <div className="bg-card border border-border rounded-2xl p-4 space-y-3">
      {/* Top row */}
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 bg-secondary/10 rounded-xl flex items-center justify-center flex-shrink-0 text-xl">
            {METHOD_ICON[methodKey]}
          </div>
          <div>
            <p className="font-bold text-foreground">{customerName}</p>
            <p className="text-xs text-muted-foreground">{payment.name}</p>
          </div>
        </div>
        <div className="text-left">
          <p className="text-lg font-black text-secondary">{fmt(payment.amount)} {cur()}</p>
          <p className="text-xs text-muted-foreground">{dateStr}</p>
          {timeStr && <p className="text-[11px] text-muted-foreground">{timeStr}</p>}
        </div>
      </div>

      {/* Meta row */}
      <div className="flex items-center gap-2 flex-wrap">
        {showRep && repName && (
          <span className="text-xs bg-amber-50 text-amber-700 border border-amber-200 rounded-full px-2.5 py-0.5 font-semibold">🧭 {repName}</span>
        )}
        <span className="text-xs bg-emerald-50 text-emerald-700 border border-emerald-200 rounded-full px-2.5 py-0.5 font-semibold">✅ مكتمل</span>
        <span className="text-xs bg-muted text-muted-foreground rounded-full px-2.5 py-0.5">{METHOD_LABEL[methodKey]}</span>
        {payment.ref && <span className="text-xs text-muted-foreground">مرجع: {payment.ref}</span>}
      </div>

      {/* Actions */}
      <div className="flex gap-2 border-t border-border pt-2">
        <button onClick={() => navigate(`/collections/${payment.id}`)}
          className="flex-1 flex items-center justify-center gap-1.5 text-xs font-semibold text-primary py-2 rounded-xl hover:bg-primary/5 transition-colors">
          <Eye className="w-3.5 h-3.5" /> عرض
        </button>
        <button onClick={() => window.print()}
          className="flex-1 flex items-center justify-center gap-1.5 text-xs font-semibold text-muted-foreground py-2 rounded-xl hover:bg-muted transition-colors">
          <Printer className="w-3.5 h-3.5" /> طباعة
        </button>
        <button onClick={() => onShare?.(payment)}
          className="flex-1 flex items-center justify-center gap-1.5 text-xs font-semibold text-muted-foreground py-2 rounded-xl hover:bg-muted transition-colors">
          <Share2 className="w-3.5 h-3.5" /> مشاركة
        </button>
      </div>
    </div>
  );
}